<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:23:35
 * @FilePath: /smartEarthDemo/src/demo/earth/adminiface.vue
 * @Description: 
-->
<template>
    <div id="cesiumContainer"></div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    mounted () {
     this.init()
    },
    methods : {
      init () {
          let viewerOption = {
                    geocoder: false, // 地理位置查询定位控件
                    homeButton: false, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: false, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: false, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,

                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                };

                let viewer = new Cesium.Viewer(this.$el, viewerOption);

                viewer.scene.sun.destroy(); //去掉太阳
                viewer.scene.sun = undefined; //去掉太阳
                viewer.scene.moon.destroy(); //去掉月亮
                viewer.scene.moon = undefined; //去掉月亮
                viewer._cesiumWidget._creditContainer.style.display = "none";

                let promise = Cesium.GeoJsonDataSource.load('/demo/static/data/geojson/bj_region.geojson');
                 promise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);
                    let entities = dataSource.entities.values;
                    let colorHash = {};
                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];
                        let name = entity.name;
                        let color = colorHash[name];
                        if (!color) {
                            color = Cesium.Color.fromRandom({
                                alpha: 1.0
                            });
                            colorHash[name] = color;
                        }
                        entity.polygon.material = color;
                        // entity.polygon.outline = true;
                        // entity.polygon.extrudedHeight = entity.properties.Population / 50.0;
                        entity.polygon.extrudedHeight = 8000;
                    }
                    viewer.zoomTo(entities);
                }).otherwise(function (error) {
                    window.alert(error);
                });
         }
    }
}
</script>
<style scoped>
  #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
